//=====================================================
//　患者詳細情報
//=====================================================
import { useState } from "react";

//患者詳細情報IF
export interface IFDataPatientDetailInfo {
    done?: boolean,
    message?: string,
    patientId?: string,
    password?: string,
    firstName?: string,
    lastName?: string,
    firstNameKana?: string,
    lastNameKana?: string,
    postCode1?: string,
    postCode2?: string,
    address?: string,
    tel?: string,
    telPrivate?: string,
    birthday?: string,
    email?: string,
    visitNotificationMail?: boolean,
    endNotificationMail?: boolean,
    visitNotificationSms?: boolean,
    endNotificationSms?: boolean
}

//患者詳細情報初期値定数
export const InitDataPatientDetailInfo:IFDataPatientDetailInfo = {
    done: false,
    message: "",
    patientId: "",
    password: "",
    firstName: "",
    lastName: "",
    firstNameKana: "",
    lastNameKana: "",
    postCode1: "",
    postCode2: "",
    address: "",
    tel: "",
    telPrivate: "",
    birthday: "",
    email: "",
    visitNotificationMail: false,
    endNotificationMail: false,
    visitNotificationSms: false,
    endNotificationSms: false
}

//患者詳細情報管理IF
export interface IFUsePatientDetailInfo {
    data: IFDataPatientDetailInfo,
    update: (val: IFDataPatientDetailInfo) => void,
}

export function usePatientDetailInfo():IFUsePatientDetailInfo{

    const [data, setData] = useState<IFDataPatientDetailInfo>(InitDataPatientDetailInfo);
    
    //-----------------------------------------------------
    //　更新
    //-----------------------------------------------------
    function update(val: IFDataPatientDetailInfo, createData?: IFDataPatientDetailInfo) {
        
        let newData:IFDataPatientDetailInfo;
        if (createData){
            newData = Object.assign({}, createData);
        } else {
            newData = Object.assign({}, data);
        }

        if (val.done !== undefined ){newData.done = val.done};
        if (val.patientId !== undefined){newData.patientId = val.patientId};
        if (val.lastName !== undefined){newData.lastName = val.lastName};
        if (val.firstName !== undefined){newData.firstName = val.firstName};
        if (val.lastNameKana !== undefined){newData.lastNameKana = val.lastNameKana};
        if (val.firstNameKana !== undefined){newData.firstNameKana = val.firstNameKana};
        if (val.postCode1 !== undefined){newData.postCode1 = val.postCode1};
        if (val.postCode2 !== undefined){newData.postCode2 = val.postCode2};
        if (val.address !== undefined){newData.address = val.address};
        if (val.tel !== undefined){newData.tel = val.tel};
        if (val.telPrivate !== undefined){newData.telPrivate = val.telPrivate};
        if (val.birthday !== undefined){newData.birthday = val.birthday};
        if (val.password !== undefined){newData.password = val.password};
        if (val.email !== undefined){newData.email = val.email};
        if (val.visitNotificationMail !== undefined ){newData.visitNotificationMail = val.visitNotificationMail};
        if (val.visitNotificationSms !== undefined ){newData.visitNotificationSms = val.visitNotificationSms};
        if (val.endNotificationMail !== undefined ){newData.endNotificationMail = val.endNotificationMail};
        if (val.endNotificationSms !== undefined ){newData.endNotificationSms = val.endNotificationSms};
        
        setData(newData);
    }
    return { data, update }
}

